import BaseListagem from "components/BaseListagem";
import ReportEdit from "components/reports/ReportEdit";
import CentroCusto from "model/administracao/cadastro/centrocusto/CentroCusto";
import Usuario from "model/administracao/cadastro/Usuario";
import Viagem from "model/viagem/Viagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTable, DataTableFilterMeta } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { SplitButton } from "primereact/splitbutton";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import ViagemService from "service/viagem/ViagemService";
import ViagemTipoDespesaService from "service/viagem/ViagemTipoDespesaService";
import { converterData, converterDataHora } from "utils/convert";
import { IdMatchModeOptions, ListMatchModeOptions, NumberMatchModeOptions, TextMatchModeOptions, dateRangeFilterTemplate, filterApplyTemplate, statusFilterTemplate } from "utils/filterUtils";
import saveAs from 'file-saver';
import { useToastContext } from "components/alert/ToastContext";
import ViagemDespesaService from "service/viagem/ViagemDespesaService";
import ViagemDespesa from "model/viagem/ViagemDespesa";
import ViagemTipoDespesa from "model/viagem/ViagemTipoDespesa";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";

const viagemService = new ViagemService();
const viagemDespesaService = new ViagemDespesaService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function ViagemDespesaListagem() {

    const [queryParameters] = useSearchParams();
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();
    const navigate = useNavigate();

    const [titulo, setTitulo] = useState<string>('Despesas');
    const [usuariosDisponiveis, setUsuariosDisponiveis] = useState<Usuario[]>([]);
    const [centrosCustoDisponiveis, setCentrosCustoDisponiveis] = useState<CentroCusto[]>([]);
    const [tiposDespesaDisponiveis, setTiposDespesaDisponiveis] = useState<ViagemTipoDespesa[]>([]);
    const [visibleDialogRelatorios, setVisibleDialogRelatorios] = useState(false);
    const [editaRelatorios, setEditaRelatorios] = useState(false);

    useEffect(() => {
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            if (usuarioLogadoService.usuarioTemAlgumaAcao(resposta, ["RELATORIO_VIAGEM_DESPESA_LISTAGEM_EDITAR"])) {
                setEditaRelatorios(true);
            }
        }).catch((erro) => {
            console.log(erro);
        });
        viagemService.getUsuariosDisponiveis().then((response) => {
            setUsuariosDisponiveis(response)
        }).catch(err => {
            console.error(err);
        })
        viagemService.getCentroCustoDisponiveis().then((response) => {
            setCentrosCustoDisponiveis(response)
        }).catch(err => {
            console.error(err);
        });
        viagemDespesaService.getTiposDespesa().then((response) => {
            setTiposDespesaDisponiveis(response)
        }).catch(err => {
            console.error(err);
        });
    }, [])

    const defaultFilters: DataTableFilterMeta = {
        codigoViagem: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        usuarioSolicitante: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        centroCusto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        dataDespesa: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        itinerario: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        tipoDespesa: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        observacao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        valor: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        situacao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
    }
    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);

    const usuarioFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={usuariosDisponiveis} filter
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    const centroCustoFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={centrosCustoDisponiveis}
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    const tipoDespesaFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={tiposDespesaDisponiveis}
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    function getButtonsExtra() {
        return [
            editaRelatorios ? <SplitButton
                icon="pi pi-file-pdf"
                style={{ marginRight: 8 }}
                onClick={() => gerarRelatorioListagem()}
                model={[{
                    label: "Alterar relatórios",
                    command: () => setVisibleDialogRelatorios(true)
                }]}
            /> : <Button
                type="button"
                icon="pi pi-file-pdf"
                style={{ marginRight: 8 }}
                onClick={() => gerarRelatorioListagem()}
            />
        ]
    }

    function gerarRelatorioListagem() {
        startLoading();
        viagemDespesaService.getRelatorioListagem(filters).then(data => {
            stopLoading();
            const file = new Blob([data], { type: 'application/pdf' });
            saveAs(file, `Despesas.pdf`);
        }).catch(err => {
            stopLoading();
            msgErro("Erro ao gerar Relatório", err.message);
            console.log(err);
        });
    }

    function navegarParaViagem(idViagem: number) {
        let url = `/viagem/editar/${idViagem}`;
        navigate(`${url}`);
    }

    const footerGroup = (totalizadores: any) => {
        return <ColumnGroup>
            <Row>
                <Column footer="Total:" colSpan={9} footerStyle={{ textAlign: 'right' }} />
                <Column footer={totalizadores?.valor ? "R$ " + totalizadores?.valor.toFixed(2).replace(".", ",") : "R$ 0,00"} />
                <Column />
            </Row>
        </ColumnGroup>
    }

    const rowExpansionTemplate = (data: ViagemDespesa) => {
        return <DataTable value={data.aprovacoes} size="small" header="Aprovações">
            <Column field="usuario.nome" header="Aprovador" />
            <Column field="situacao" header="Situação" body={(rowData) => viagemDespesaService.getSituacaoAprovacao(rowData.situacao)} />
            <Column field="dataAprovacao" header="Data aprovação" body={(rowData) => converterDataHora(rowData.dataAprovacao)} />
        </DataTable>
    }


    return (
        <>
            <Dialog visible={visibleDialogRelatorios}
                onHide={() => setVisibleDialogRelatorios(false)}
                header="Relatórios"
                style={{ width: "50%" }}
            >
                <ReportEdit nomeAcao="RELATORIO_VIAGEM_DESPESA_LISTAGEM_EDITAR" titulo="Relatório de listagem" testarRelatorio={() => { }} style={{ marginBottom: 10 }} />
            </Dialog>
            <BaseListagem
                footerGroup={(totalizadores) => footerGroup(totalizadores)}
                ordenacao="viagem.codigo,DESC"
                buttonsExtra={getButtonsExtra()}
                service={viagemDespesaService}
                urlService="/viagemDespesa"
                tituloPagina={titulo}
                defaultFilters={defaultFilters}
                showClearFilterButton
                rowExpansionTemplate={(data) => rowExpansionTemplate(data as ViagemDespesa)}
                showNewButton={false} showEditButton={false} showRemoveButton={false}
                nome="viagemDespesa" onChangeFilters={(filters) => setFilters(filters)}  >
                <Column expander={(rowData: ViagemDespesa) => rowData.aprovacoes && rowData.aprovacoes.length > 0} style={{ width: '3em' }} />
                <Column
                    field="viagem.codigo" header="Nr." filterField="codigoViagem"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate}
                />

                <Column
                    field="viagem.usuarioSolicitante.nome" header="Solicitante" filterField="usuarioSolicitante"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={usuarioFilterTemplate}
                />
                <Column
                    field="viagem.centroCusto.nome" header="Centro de custo" filterField="centroCusto"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={centroCustoFilterTemplate}
                />
                <Column
                    field="viagem.itinerario" header="Itinerário" filterField="itinerario"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}
                />
                <Column
                    field="tipo.nome" header="Tipo" filterField="tipoDespesa"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={tipoDespesaFilterTemplate} />

                <Column field="observacao" header="Observação" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />

                <Column field="dataDespesa" header="Dt. Despesa" body={(rowData: ViagemDespesa) => converterData(rowData.dataDespesa)}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="dataDespesa"
                    filterElement={dateRangeFilterTemplate} showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterMenuStyle={{ zIndex: 50 }}
                />
                <Column field="situacao" header="Situação" body={(rowData) => viagemDespesaService.getSituacao(rowData.situacao)}
                    filterField="situacao" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={(options) => statusFilterTemplate(options, viagemDespesaService.getStatusFilter())}
                />
                <Column
                    field="valor" header="Valor" body={(rowData: ViagemDespesa) => rowData.valor?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) || ""}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate}
                />
                <Column body={(rowData) => <Button icon="pi pi-pencil" onClick={() => navegarParaViagem(rowData.viagem.id)} />} />
            </BaseListagem>
        </>
    )
}